import React,{useState,useLayoutEffect} from 'react'
import { HeaderAlt, HeaderAltMobile } from "../../styles/Header";

import CategoryLoader from '../Content/CategoryLoader';

import { useProductRequests } from '../../helpers/ProductRequests';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faArrowDown, faArrowUp, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import useWindowDimensions from '../useWindowDimensions';
const Foo = () => {
  return <div>hello foo</div>;
};
const Bar = () => {
  return <div>hello b</div>;
};
export default function Categories({open,setOpen}) {

  const {getCategories} = useProductRequests();

  const [categories, setCategories] = useState([])

  const history=useHistory()

  useLayoutEffect(() => {
    
    if(categories.length === 0){
      getCategories().then((response)=>{
        setCategories(response.data.data)
      }).catch((error)=>{
        console.log("error",error.response)
      })
    }
    
  }, [])
  const data = [
  {
    label: "foo",
    key: 1,
    items: <Foo />
  },
  {
    label: "bar",
    key: 2,
    items: <Bar />
  },
  {
    label: "Category2",
    key: "Category3",
    items: "Category3 content"
  }
];
const [selected, setSelected] = useState(null);
const width=useWindowDimensions().width
  return (
    <>
      <HeaderAltMobile open={open}>
        <div className='overlay' onClick={() => setOpen(false)}></div>
        <button className="close-btn" onClick={() => setOpen(false)}>
          x
        </button>
        <div style={{ marginTop: 100 }}>
          <h1 style={{ padding: 10, textAlign: "center" }}>Kategoriler</h1>
          <ul>
            {categories != null &&
            categories != undefined &&
            categories.length > 0 ? (
              <>
                {categories.map((category, index) => {
                  return (
                    <li key={"ctgm" + category.slug} className={category.name}>
                      <button>
                        <div>
                          <span
                            onClick={() =>
                              history.push({
                                pathname: "/kategori/" + category.slug,
                              })
                            }
                            style={{ width: "100%" }}
                          >
                            {category.name}
                          </span>
                          <FontAwesomeIcon
                            onClick={() =>
                              setSelected(
                                selected == category.slug ? null : category.slug
                              )
                            }
                            style={{
                              width: 200,
                              textAlign: "right",
                              minHeight: 20,
                              transition: 500 + "ms all",
                              transform:
                                selected == category.slug
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                            }}
                            icon={faAngleDown}
                          />
                        </div>
                      </button>
                      {/* Alt  kategoriler burada ;  */}
                      {category.subGroups.length > 0 &&
                      (history.location.pathname.indexOf("/kategori/") == -1 ||
                        width < 1140) ? (
                        <>
                          <div
                            className="sub-category"
                            style={{
                              transform:
                                selected == category.slug
                                  ? "scale(1)"
                                  : "scale(0)",
                              height: selected == category.slug ? "unset" : "0",
                            }}
                          >
                            {category.subGroups.map((sub_category, index) => {
                              return (
                                <button
                                  key={"sb-s" + sub_category.slug}
                                  onClick={() =>
                                    history.push(
                                      "/kategori/" + sub_category.slug
                                    )
                                  }
                                >
                                  <div
                                    className="ct-image"
                                    style={{
                                      backgroundImage: `url(${
                                        sub_category.image != null &&
                                        sub_category.image != ""
                                          ? sub_category.image
                                          : "https://www.fornxt.net/aktarimlar/13346786/108214-1.jpg"
                                      })`,
                                    }}
                                  />
                                  <span>
                                    {sub_category.name
                                      .toUpperCase()
                                      .replace(/\//g, " / ")}
                                  </span>
                                </button>
                              );
                            })}
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </li>
                  );
                })}
              </>
            ) : (
              <>
                <CategoryLoader head={"li"} count={10} />
              </>
            )}

            <li>
              <button onClick={() => history.push({ pathname: "/modeller" })}>
                <span>Modeller</span>
              </button>
            </li>

            <li>
              <button
                onClick={() => history.push({ pathname: "/yeni-urunler" })}
              >
                <span>Yeni Ürünler</span>
              </button>
            </li>
            {/* <li>
          <button
            onClick={() => history.push({ pathname: "/kampanyali-urunler" })}
          >
            <span>Kampanya</span>
          </button>
        </li> */}
          </ul>
        </div>
      </HeaderAltMobile>
      {open ? (
        <></>
      ) : (
        <HeaderAlt>
          <ul>
            {categories != null &&
            categories != undefined &&
            categories.length > 0 ? (
              <>
                {categories.map((category, index) => {
                  return (
                    <li key={"ctg" + category.slug} className={category.name}>
                      <button
                        onClick={() =>
                          history.push({
                            pathname: "/kategori/" + category.slug,
                          })
                        }
                      >
                        <span>{category.name}</span>
                      </button>
                      {/* Alt  kategoriler burada ;  */}
                      {category.subGroups.length > 0 &&
                      (history.location.pathname.indexOf("/kategori/") == -1 ||
                        width < 1140) ? (
                        <>
                          <div
                            className="sub-category"
                            style={{
                              background:
                                category.name == "KADIN" ? "#eee" : "#eee",
                            }}
                          >
                            {category.subGroups.map((sub_category, index) => {
                              return (
                                <button
                                  key={"sb-s" + sub_category.slug}
                                  onClick={() =>
                                    history.push(
                                      "/kategori/" + sub_category.slug
                                    )
                                  }
                                >
                                  <kategori
                                    className="ct-image"
                                    style={{
                                      backgroundImage: `url(${
                                        sub_category.image != null &&
                                        sub_category.image != ""
                                          ? sub_category.image
                                          : "https://www.fornxt.net/aktarimlar/13346786/108214-1.jpg"
                                      })`,
                                    }}
                                  />
                                  <span>
                                    {sub_category.name
                                      .toUpperCase()
                                      .replace(/\//g, " / ")}
                                  </span>
                                </button>
                              );
                            })}
                          </div>
                        </>
                      ) : (
                        // <div>
                        //   <CategoryLoader head={'li'} count={10} />
                        // </div>
                        <></>
                      )}
                    </li>
                  );
                })}
              </>
            ) : (
              <>
                <CategoryLoader head={"li"} count={10} />
              </>
            )}

            <li>
              <button onClick={() => history.push({ pathname: "/modeller" })}>
                <span>Modeller</span>
              </button>
            </li>

            <li>
              <button
                onClick={() => history.push({ pathname: "/yeni-urunler" })}
              >
                <span>Yeni Ürünler</span>
              </button>
            </li>
            {/* <li>
          <button
            onClick={() => history.push({ pathname: "/kampanyali-urunler" })}
          >
            <span>Kampanya</span>
          </button>
        </li> */}
          </ul>
        </HeaderAlt>
      )}
    </>
  );
}
